module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-christmas-7713a848d220f51ca2c0476a920c4d32.svg";